module.exports = __webpack_public_path__ + "img/payment_s.352b3376.svg";